/**
 * Shared chrome for the controls that float over the angle image — the ⋯
 * concept menu and the render-carousel arrows, on both the main angle and the
 * derivative cards. One constant so the two call sites can never drift.
 *
 * Matches Apple `anglePillBackground` and Android `angleOverlayPill`: a
 * frosted backdrop blur of the image (Apple `.ultraThinMaterial`) under a
 * light white veil, with solid black glyphs. Same in both themes, like Apple:
 * the pill reads off the photo it blurs, not off the page around it. The
 * former 35% white with a #545454 glyph all but vanished over a bright sky.
 */
export const ANGLE_OVERLAY_PILL =
  'before:bg-white/45 before:backdrop-blur-[20px]';

/** Glyph tint that pairs with {@link ANGLE_OVERLAY_PILL}. */
export const ANGLE_OVERLAY_GLYPH = '[&_svg]:text-black';

/** Both halves, for buttons that carry an icon (the ⋯ menu). */
export const ANGLE_OVERLAY_BUTTON = `${ANGLE_OVERLAY_GLYPH} ${ANGLE_OVERLAY_PILL}`;
